import easyfyAxios from '@shared/easyfy.axios';

namespace Meds.Web.Services.Review {
  export interface ProductReviewRequest {
    productId: string;
    productEAN?: string;
    rating: number;
    nickname: string,
    comment?: string;
    orderCustomer: string;
  }

  export interface GetProductReviewsRequest {
    productId: string;
    page: number;
    pageSize?: number;
    ratings?: number[];
    onlyWithComments: boolean;
  }

  export const SubmitProductReview = async (
    data: ProductReviewRequest
  ): Promise<any> => {
    const url = `/api/productreview?handler=submit`;
    return easyfyAxios.post(
      url,
      data,
      null
    );
  };

  export const GetProductReviews = async (
    data: GetProductReviewsRequest
  ): Promise<any> => {

    let filterQueryString = `&productid=${data.productId}&page=${data.page}&onlywithcomments=${data.onlyWithComments}`;

    if (data.pageSize) {
      filterQueryString += `&pagesize=${data.pageSize}`;
    }

    if (data.ratings) {
      filterQueryString += `&ratings=${data.ratings}`;
    }

    const url = `/api/productreview?handler=productreviews${filterQueryString}`;

    return easyfyAxios.get(
      url
    );
  };
}

export default Meds.Web.Services.Review;
